import React from 'react';
import logo from 'assets/img/brand/company_logo.png';
import { moneyFormatter } from 'utli';
import './printStyle.scss';
import moment from 'moment';

class DepositInvoicePrintComponent extends React.Component {
  
  // Helper method to render header section
  renderHeader = (pageNumber = null, totalPages = null) => (
    <div className='print-header'>
      <div className='header-row'>
        <div className='logo-section'>
          <div className='logo-wrapper'>
            <img src={logo} alt='Company Logo' className='company-logo' />
            <div className='company-info'>
              <p className='company-name'>EASTY FREIGHT INTERNATIONAL LOGISTICS COMPANY LIMITED</p>
              <p className='company-address'>[No.47, May Kha Street, May Kha Housing, Thingangyun Twsp, Yangon]</p>
            </div>
          </div>
        </div>
        <div className='invoice-title'>
          <h1>DEPOSIT INVOICE</h1>
          <h3>[ Import License ]</h3>
          {pageNumber && totalPages && (
            <p style={{ fontSize: '12px', marginTop: '10px' }}>
              Page {pageNumber} of {totalPages}
            </p>
          )}
        </div>
      </div>
      <div className='header-border'></div>
    </div>
  );

  // Helper method to render info sections (only on first page)
  renderInfoSections = (data) => (
    <>
      {/* Date and Sale Person */}
      <div className='info-row'>
        <table className='info-table'>
          <tbody>
            <tr>
              <td className='label-cell'>Date</td>
              <td className='value-cell'>{data?.invoice_date ? moment(data.invoice_date).format('DD-MMM-YYYY') : '-'}</td>
            </tr>
            <tr>
              <td className='label-cell'>Sale Person</td>
              <td className='value-cell'>{data?.sale_person?.name || '-'}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Customer and Deposit Information */}
      <div className='main-info-section'>
        <div className='customer-info'>
          <h3 className='section-title'>Customer Information</h3>
          <div className='info-item'>
            <span className='label'>Customer Name</span>
            <span className='value'>{data?.receiver?.name || '-'}</span>
          </div>
          <div className='info-item'>
            <span className='label'>Customer Code</span>
            <span className='value'>{data?.address_code || '-'}</span>
          </div>
          <div className='info-item'>
            <span className='label'>Customer Address</span>
            <span className='value'>{data?.receiver?.address || '-'}</span>
          </div>
          <div className='info-item'>
            <span className='label'>Contact Phone No.</span>
            <span className='value'>{data?.receiver?.phone || '-'}</span>
          </div>
        </div>

        <div className='deposit-info'>
          <div className='deposit-info-container'>
            <h3 className='section-title'>Deposit Information</h3>
            <div className='info-item'>
              <span className='label'>Deposit No.</span>
              <span className='value'>{data?.invoice_number || '-'}</span>
            </div>
            <div className='info-item'>
              <span className='label'>Quotation No.</span>
              <span className='value'>{data?.quotation_no || '-'}</span>
            </div>
            <div className='info-item'>
              <span className='label'>DIL No.</span>
              <span className='value'>{data?.dil_no || '-'}</span>
            </div>
            <div className='info-item'>
              <span className='label'>Payment Method</span>
              <span className='value' style={{color:"black"}}>{data?.paymentType?.name?.trim() || 'COD'}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  // Helper method to render table header
  renderTableHeader = (data) => (
    <thead>
      <tr>
        <th className='sr-col'>SR NO</th>
        <th className='item-col'>ITEM NAME</th>
        <th className='unit-col'>UNIT</th>
        <th className='qty-col'>QTY</th>
        <th className='particulars-col'>PARTICULARS</th>
        <th className='amount-col'>AMOUNT ({data?.currency})</th>
      </tr>
    </thead>
  );

  // Helper method to render payment terms (only on last page)
  renderPaymentTerms = () => (
    <div className='payment-terms'>
      <h3 className='section-title'>Payment Terms</h3>
      <ol>
        <li>Payment must be made within 3 working days from the date of this deposit invoice.</li>
        <li>Deposit will be adjusted against the Actual Import Licence fee once approved.</li>
        <li>If the actual licence fee exceeds the deposit, the balance shall be collected from the customer.</li>
      </ol>
    </div>
  );

  // Helper method to render bank information (only on last page)
  renderBankInformation = () => (
    <div className='bank-section'>
      <h3 className='section-title'>Bank Information for Payment</h3>
      <table className='bank-table'>
        <thead>
          <tr>
            <th className='sr-col'>Sr.</th>
            <th className='bank-name-col'>Bank Name</th>
            <th className='account-name-col'>Account Name</th>
            <th className='account-number-col'>Account Number</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>KBZ-BANK</td>
            <td>U SOE MIN ZAW</td>
            <td>0275 110 3800 226 801</td>
          </tr>
          <tr>
            <td>2</td>
            <td>YOMA-BANK</td>
            <td>U SOE MIN ZAW</td>
            <td>000 345 480 000 813</td>
          </tr>
          <tr>
            <td>3</td>
            <td>CB-BANK</td>
            <td>U SOE MIN ZAW</td>
            <td>0003 1009 0000 9938</td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  // Helper method to render signatures (only on last page)
  renderSignatures = () => (
    <div className='signature-section' style={{marginTop:"95px"}}>
      <div className='signature-box'>
        <p className='signature-title'>Received By / Customer</p>
        <div className='signature-line'></div>
        <p className='signature-label'>Signature</p>
        <p className='signature-label'>Name</p>
      </div>
      <div className='signature-box'>
        <p className='signature-title'>Checked By / Finance</p>
        <div className='signature-line'></div>
        <p className='signature-label'>Signature</p>
        <p className='signature-label'>Name</p>
      </div>
      <div className='signature-box'>
        <p className='signature-title'>Verified By / Sales</p>
        <div className='signature-line'></div>
        <p className='signature-label'>Signature</p>
        <p className='signature-label'>Name</p>
      </div>
    </div>
  );

  render() {
    const { data } = this.props;

    if (!data) return null;

    // Calculate total amount from items
    const totalAmount = data?.items?.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0) || data?.total_amount || 0;
    
    const items = data?.items || [];
    const itemsPerPage = 15;
    const totalPages = Math.ceil(items.length / itemsPerPage);
    
    console.log('DepositInvoice Pagination Debug:', {
      totalItems: items.length,
      itemsPerPage,
      totalPages,
      willPaginate: items.length > itemsPerPage
    });
    
    // If items are 25 or less, render single page
    if (items.length <= itemsPerPage) {
      return (
        <div className='deposit-invoice-print'>
          {this.renderHeader()}
          {this.renderInfoSections(data)}
          
          {/* License & Service Details */}
          <div className='service-section'>
            <h3 className='section-title'>License & Service Details</h3>
            <table className='items-table'>
              {this.renderTableHeader(data)}
              <tbody>
                {items.length > 0 ? (
                  <>
                    {items.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}.</td>
                        <td style={{textAlign: 'left'}}>{item.itemname || '-'}</td>
                        <td>{item.unit || '-'}</td>
                        <td>{item.qty || '-'}</td>
                        <td>{item.remark || '-'}</td>
                        <td style={{ textAlign: 'right' }}>{item.amount ? moneyFormatter(item.amount) : '-'}</td>
                      </tr>
                    ))}
                    {/* Subtotal Row */}
                    <tr className='total-row subtotal-row'>
                      <td colSpan='5' className='total-label'>SUB TOTAL</td>
                      <td className='total-amount'>{moneyFormatter(totalAmount)}</td>
                    </tr>
                  </>
                ) : (
                  <tr>
                    <td colSpan='6' className='center'>No items</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          
          {this.renderPaymentTerms()}
          {this.renderBankInformation()}
          {this.renderSignatures()}
        </div>
      );
    }

    // Multiple pages rendering
    const pages = [];
    for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
      const startIndex = pageIndex * itemsPerPage;
      const endIndex = Math.min(startIndex + itemsPerPage, items.length);
      const pageItems = items.slice(startIndex, endIndex);
      const isFirstPage = pageIndex === 0;
      const isLastPage = pageIndex === totalPages - 1;

      pages.push(
        <div key={pageIndex} className={`deposit-invoice-print ${!isLastPage ? 'page-break' : ''}`}>
          {this.renderHeader(pageIndex + 1, totalPages)}
          
          {/* Only show info sections on first page */}
          {isFirstPage && this.renderInfoSections(data)}
          
          {/* License & Service Details */}
          <div className='service-section'>
            <h3 className='section-title'>License & Service Details {!isFirstPage && `(Continued)`}</h3>
            <table className='items-table'>
              {this.renderTableHeader(data)}
              <tbody>
                {pageItems.map((item, index) => (
                  <tr key={startIndex + index}>
                    <td>{startIndex + index + 1}.</td>
                    <td style={{textAlign: 'left'}}>{item.itemname || '-'}</td>
                    <td>{item.unit || '-'}</td>
                    <td>{item.qty || '-'}</td>
                    <td>{item.remark || '-'}</td>
                    <td style={{ textAlign: 'right' }}>{item.amount ? moneyFormatter(item.amount) : '-'}</td>
                  </tr>
                ))}
                
                {/* Show subtotal only on last page */}
                {isLastPage && (
                  <tr className='total-row subtotal-row'>
                    <td colSpan='5' className='total-label'>SUB TOTAL</td>
                    <td className='total-amount'>{moneyFormatter(totalAmount)}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          
          {/* Only show payment terms, bank info and signatures on last page */}
          {isLastPage && (
            <>
              {this.renderPaymentTerms()}
              {this.renderBankInformation()}
              {this.renderSignatures()}
            </>
          )}
        </div>
      );
    }

    console.log('DepositInvoice Total pages created:', pages.length);

    return (
      <div className="multi-page-container">
        {pages}
      </div>
    );
  }
}

export default DepositInvoicePrintComponent;
